import * as RasaInput from '../../components/rasa-input';
import * as Constants from './constants'
import * as Types from './types'

export const dropdownTypesByName = (options: Types.ReferenceData[]): RasaInput.DropdownOption[] => {
  return options.map((option: Types.ReferenceData) => ({
    description: option.description,
    key: option.name,
  }))
}

export const dropdownTypesById = (options: Types.ReferenceData[]): RasaInput.DropdownOption[] => {
  return options.map((option: Types.ReferenceData) => ({
    description: option.description,
    key: option.id,
  }))
}

const SELECT_PROMOTION_CATEGORY: RasaInput.DropdownOption = {
  description: 'Select a category',
  key: 0,
}

export const subscriptionTypesById = (): RasaInput.DropdownOption[] =>
  dropdownTypesById(Constants.SUBSCRIPTION_TYPES)
export const subscriptionTypesByName = (): RasaInput.DropdownOption[] =>
  dropdownTypesByName(Constants.SUBSCRIPTION_TYPES)

export const promotionCategoryTypesById = (includeEmpty: boolean): RasaInput.DropdownOption[] => {
  return [
    ...(includeEmpty ? [SELECT_PROMOTION_CATEGORY] : []),
    ...dropdownTypesById(Constants.PROMOTION_CATEGORIES),
  ]
}

export const promotionCategoryTypesByName = (): RasaInput.DropdownOption[] =>
  dropdownTypesByName(Constants.PROMOTION_CATEGORIES)

export const sourceTypesById = (): RasaInput.DropdownOption[] => dropdownTypesById(Constants.SOURCE_TYPES)
export const sourceTypesByName = (): RasaInput.DropdownOption[] => dropdownTypesByName(Constants.SOURCE_TYPES)



// WEBPACK FOOTER //
// ./src/pages/reference/utils.ts